module.exports = __webpack_public_path__ + "img/2.075be875.png";